/** ---------------------------- Interfaces -----------------------------  */
// User data interface
export interface CertificateData {
    id: string,
    accountName: string,
    certificateId: string,
    validTo: string,
    status: string
}

/**------------------------------ Constants -------------------------------- */

// Certificate Status constant
export const CERTIFICATE_STATUS = {
  SUSPENDED: 'Suspended',
  TERMINATED: 'Terminated',
  CERTIFIED: 'Certified'
} as const;


// Per page recods
const DATA_PER_PAGE = 10;

// User table header list
const CERTIFICATE_LIST_HEADER = [
    "Account Name",
    "Certificate ID",
    "Valid To"
];

// Export all constants
export const CertificatesConstants = {
    DATA_PER_PAGE,
    CERTIFICATE_LIST_HEADER
}
